import React from 'react';

import { ContractSummaryCard } from '../components/ContractSummaryCard';
import { ContractTilesGrid } from '../components/ContractTilesGrid';
import { CARD_LOAN_TYPES, ContractView } from '../ContractTab';
import { CardContractOverview } from './CardContractOverview';

type ContractOverviewProps = {
  contractId: string;
  contractIds: string[];
  contractAuxIds?: Record<string, number>;
  loading: boolean;
  contractDetails: any;
  hasAuxId?: boolean;
  onNavigate: (view: ContractView) => void;
  onContractChange: (id: string) => void;
};

export function ContractOverview({
  contractId,
  contractIds,
  contractAuxIds,
  loading,
  contractDetails,
  hasAuxId,
  onNavigate,
  onContractChange,
}: Readonly<ContractOverviewProps>) {
  const isCard = CARD_LOAN_TYPES.includes(contractDetails?.loanType as any);

  if (isCard && hasAuxId) {
    return (
      <CardContractOverview
        contractId={contractId}
        contractIds={contractIds}
        contractAuxIds={contractAuxIds}
        loading={loading}
        contractDetails={contractDetails}
        onNavigate={onNavigate}
        onContractChange={onContractChange}
      />
    );
  }

  return (
    <div>
      <ContractSummaryCard
        contractId={contractId}
        contractIds={contractIds}
        contractAuxIds={contractAuxIds}
        loading={loading}
        contractDetails={contractDetails}
        onContractChange={onContractChange}
        onMoreDetails={() => onNavigate('details')}
      />

      <ContractTilesGrid loading={loading} onNavigate={onNavigate} loanType={contractDetails?.loanType} />
    </div>
  );
}
